export const  ROUTER_LOGIN  = {

      REGISTER : {
          FORM : '/auth/register',
      },
      LOGIN : {
        FORM : '/auth/',


      },
      CREATE_ACCOUNT : {
        FORM : '/auth/create-account',


      },




}
